import { useContext, useState } from 'react';

import Button from '../../button/button.component';

import { ToastContext } from '../../../../contexts/toast.context';

import {
    ContentContainer,
    Input,
    Label,
    Textarea
} from '../../../../styles/component.styles';

const ProductFormMerchandise = ({ product = null, category, productType, action, buttonName = 'Add Product' }) => {
    const [ name, setName ] = useState(product ? product.name : '');
    const [ description, setDescription ] = useState(product ? product.description : '');
    
    const { errorToast } = useContext(ToastContext);

    const addProduct = async () => {
        if(name === '' || 
            description === ''
        ) {
            errorToast('Please fill out all fields.');
            return;
        }

        const data = {
            category,
            productType,
            name,
            description
        };

        await action(data);
    }

    return (
        <ContentContainer>
            <Input type='text' name='name' value={name} onChange={(e) => setName(e.target.value)} placeholder='Name' />
            <Textarea name='description' value={description} onChange={(e) => setDescription(e.target.value)} placeholder='Description' />

            <ContentContainer margin='20px'>
                <Button onClick={() => addProduct()}>{ buttonName }</Button>
            </ContentContainer>
        </ContentContainer>
    )
}

export default ProductFormMerchandise;